import * as amplitude from '@amplitude/analytics-browser';

export const initAmplitude = (): boolean => {
    const apiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;

    if (!apiKey) {
        console.warn('Amplitude API key missing, skipping initialization');
        return false;
    }

    amplitude.init(apiKey, {
        autocapture: {
            pageViews: false,
            sessions: true,
        },
        serverZone: 'EU',
    });
    return true;
};
